import { createContext } from 'react';
import { makeAutoObservable, observable } from 'mobx';
import { getTypeSampleSourceById } from '../../services/typeSampleSource.services';

class AppStore {
  typeSampleSourceSelected = {
    id: null,
    name: '',
    description: '',
    is_active: true,
    updated_at: null,
    sources_count: null,
    user_fields_count: 0,
    user_fields: [],

    currentPage: 1,
    limit: 10,
    sortField: { name: 'asc' },
    searchValue: '',

    pagination: {},

    selectedArray: [],
    globalFields: [],
    deleted_fields: [],

    activeFieldTabId: 1,
    icon: null,
    folder: null,
    folders: [],
  };

  constructor() {
    makeAutoObservable(this, {
      typeSampleSourceSelected: observable,
    });
  }

  setTypeSampleSourceId = async (id) => {
    const res = await getTypeSampleSourceById(id);
    for (const key of Object.keys(res.result)) {
      this.typeSampleSourceSelected[key] = res.result[key];
    }
  };

  getStore = () => {
    return {
      typeSampleSourceSelected: this.typeSampleSourceSelected,
    };
  };

  setStore = (data) => {
    if (data) {
      this.typeSampleSourceSelected = data.typeSampleSourceSelected;
    }
  };

  clearTypeSampleSourceField = () => {
    this.typeSampleSourceSelected = {
      id: null,
      name: '',
      description: '',
      is_active: true,
      updated_at: null,
      sources_count: null,
      user_fields_count: 0,
      user_fields: [],

      currentPage: 1,
      limit: 10,
      sortField: { name: 'asc' },
      searchValue: '',

      pagination: {},

      selectedArray: [],
      globalFields: [],
      deleted_fields: [],

      activeFieldTabId: 1,
      icon: null,
      folder: null,
      folders: [],
    };
  };

  setTypeSampleSourceField = (key, val) => {
    const copyObj = JSON.parse(JSON.stringify(this.typeSampleSourceSelected));
    copyObj[key] = val;
    this.typeSampleSourceSelected = copyObj;
  };
}

export const TypeSampleSourceStore = createContext(new AppStore());
